export default "__VITE_ASSET__d7d6730f__"